<!-- eventPlayers.vue 里面的 this.themeItem 不是从 multipleChoiceShare_dialog.js 里面赋值，而是当前文件里面赋值 -->
<!-- 其他文件里面的 this.themeItem 是从 multipleChoiceShare_dialog.js 里面赋值 -->
<template>
  <div class="complex_multipleChoiceShare_dialog" v-if="dialogItem">
    <publicThemeDialog
      v-if="dialogItem.dialogType === 'share'"
      :currThemeObj="currThemeObj"
      :isDialogFlag="dialogItem.dialogType === 'share'"
      :dialogObj="publicThemeDialogObj"
      :axiosBaseUrl="axiosBaseUrl"
      :currGroup="platfromMenu_currGroup"
      :currCid="currCid"
      :currSid="currSid"
      :curTimeZoneItem="curTimeZoneItem"
      @publicThemeDialogEvent="publicThemeDialogHandler"
      :commitBeforeCheckoutCallback="commitBeforeCheckoutCallback"
      @actStyleItemEvent="actStyleItemEventHandler"
    ></publicThemeDialog>
    <multipleChoiceShare_dialog
      v-else
      :dialogItem="dialogItem"
      :checkListNum="localStorageChooseList.length"
      @dialogCancelEvent="dialogCancelEventHandler"
      @dialogOkEvent="dialogOkEventHandler"
    >
      <template v-slot:checkList>
        <slot name="checkList"></slot>
      </template>
    </multipleChoiceShare_dialog>
  </div>
</template>

<script>
import publicThemeDialog from '@components/base/theme/publicThemeDialog.vue'
import multipleChoiceShare_dialog from '@components/platfromBase/compreSportsMeet/multipleChoiceShare_dialog.vue'
import platfrom_createThemeItem_data_mixin from '@mixins/platfrom_createThemeItem_data'
export default {
  name: 'complex_multipleChoiceShare_dialog',
  mixins: [platfrom_createThemeItem_data_mixin],
  props: {
    themeItem: {
      type: Object,
      default: null,
    },
    platfromMenu_currGroup: {
      type: Object,
      default: null,
    },
    currThemeObj: {
      type: Object,
      default: null,
    },
    currCid: {
      default: null,
    },
    currSid: {
      default: null,
    },
    axiosBaseUrl: {
      type: String,
      default: '',
    },
    dialogItem: {
      // multipleChoiceShare_dialog
      type: [Object, null],
      default: null,
    },
    localStorageChooseList: {
      // multipleChoiceShare_dialog
      type: Array,
      default: () => {
        return []
      },
    },
    multipleChoiceShareFixedBtn_modeType: {
      type: Object,
      default: () => ({
        btnName: '',
        type: '',
        localStorageName: '',
        unit: '',
      }),
    },
    commitBeforeCheckoutCallback: {
      // publicThemeDialog
      // 提交时验证数据是否正确，有返回值： {isCheckoutFlag:true|false, errorTipText: ''}
      type: [Function, null],
      default: null,
    },
    curTimeZoneItem: {
      type: [Object, null],
      default: null,
    },
  },
  components: {
    publicThemeDialog,
    multipleChoiceShare_dialog,
  },
  created() {
    console.debug('this.themeItem:', this.themeItem)
    this.publicThemeDialogObj = {
      analysisItemId: this.themeItem.analysisItemId,
      dialogType: '',
      dialogText:
        this.dialogItem && this.dialogItem.dialogText
          ? this.dialogItem.dialogText
          : `请确认主题【${this.themeItem.analysisItemName}】的分享配置`,
      mid: this.mid ? this.mid : 0,
      useSceneArr:
        this.themeItem.useScene.indexOf(',') > -1
          ? this.themeItem.useScene.split(',')
          : [this.themeItem.useScene],
      analysisItemStyles: this.themeItem.analysisItemStyles
        ? this.themeItem.analysisItemStyles
        : null,
      graphicsId: this.themeItem.graphicsId,
      multipleChoiceShareFixedBtn_modeType: this
        .multipleChoiceShareFixedBtn_modeType
        ? this.multipleChoiceShareFixedBtn_modeType
        : null,
    }
    console.debug('this.publicThemeDialogObj:', this.publicThemeDialogObj)
    window.mixtmt_platfrom.needPublicThemeData = this.themeItem //在赛果里的分享唤出弹层时赋值，赛果外的分享在这里赋值
  },
  methods: {
    actStyleItemEventHandler(childData) {
      let publicThemeDialogObj = JSON.parse(
        JSON.stringify(this.publicThemeDialogObj)
      )
      console.debug(
        'actStyleItemEventHandler:',
        childData,
        publicThemeDialogObj
      )

      publicThemeDialogObj.analysisItemStyles.forEach((styleItem) => {
        // 多选逻辑
        if (styleItem.styleId === childData.styleId) {
          styleItem.act = !childData.act
        }

        // 单选
        // if (styleItem.styleId === childData.styleId) {
        //   styleItem.act = true
        // } else {
        //   styleItem.act = false
        // }
      })
      this.publicThemeDialogObj = publicThemeDialogObj
      this.$forceUpdate()
      console.debug(
        'actStyleItemEventHandler:',
        childData,
        publicThemeDialogObj
      )
    },
    dialogCancelEventHandler(childData) {
      // multipleChoiceShare_dialog | 创建完主题成功之后访问这个函数，关闭弹窗
      this.$emit('dialogCancelEvent', childData)
    },
    dialogOkEventHandler(childData) {
      // multipleChoiceShare_dialog
      this.$emit('dialogOkEvent', childData)
    },
    changeChooseNumEventHandler(childData) {
      // 继续向父级传递
      this.$emit('changeChooseNumEvent', childData)
    },
    getLocalStorageChooseObj() {
      return JSON.parse(
        this.$localStorage.getItem(
          this.multipleChoiceShareFixedBtn_modeType.localStorageName
        )
      )
    },
    async publicThemeDialogHandler(data) {
      console.debug(
        'complex_multipleChoiceShare_dialog publicThemeDialogHandler:',
        data
      )
      // 多选分享浮层按钮，触发创建分享接口
      // 这里分开写是因为，创建成功后没法在操作改组件内数据变化
      console.debug('complex publicThemeDialogHandler:', data, mixtmt_platfrom)
      // 无论有没有数据都要将值赋值为false
      this.isShowPublicThemeDialog = false
      window.mixtmt_platfrom.isShowPublicThemeDialog = false
      if (data && data.flag && window.mixtmt_platfrom.needPublicThemeData) {
        // 点击【取消】 data为null,所以不会触发创建分享事件
        let needPublicThemeData = JSON.parse(
          JSON.stringify(window.mixtmt_platfrom.needPublicThemeData)
        )
        let newData = JSON.parse(JSON.stringify(data))

        // 多选主题：比如【今日赛程|L屏频道预告】等
        // 组装多选的数据
        const chooseObj = this.getLocalStorageChooseObj()
        const keyArrActJson = Object.keys(needPublicThemeData.actJson)
        needPublicThemeData.actJson[keyArrActJson[0]] = chooseObj.chooseIdArr
        needPublicThemeData.actJson.timeZones = []
        chooseObj.chooseIdArr.forEach(() => {
          if (this.curTimeZoneItem && this.curTimeZoneItem.val) {
            needPublicThemeData.actJson.timeZones.push(this.curTimeZoneItem.val)
          } else {
            needPublicThemeData.actJson.timeZones.push('beijing')
          }
        })
        if (this.multipleChoiceShareFixedBtn_modeType.customkeyArrActJson) {
          // 默认大多数json里面只有单个字段id,但特殊情况json可能会传多个字段
          // 需要将 inFilterJson 的数据合到 actJson 中的逻辑已经放在了customkeyArrActJson中了
          const customkeyArrActJsonObj =
            this.multipleChoiceShareFixedBtn_modeType.customkeyArrActJson
          const customkeyArrActJson = Object.keys(customkeyArrActJsonObj)

          customkeyArrActJson.forEach((customkey) => {
            let customkeyVal = null

            if (customkeyArrActJsonObj[customkey].type === 'Array') {
              customkeyVal = []
              chooseObj.chooseItemArr.forEach((chooseItem) => {
                if (customkeyArrActJsonObj[customkey].isOnly) {
                  // 数组去重
                  if (!customkeyVal.includes(chooseItem[customkey])) {
                    customkeyVal.push(chooseItem[customkey])
                  }
                } else {
                  // 不用去重
                  customkeyVal.push(chooseItem[customkey])
                }
              })
            } else if (customkeyArrActJsonObj[customkey].type === 'String') {
              // 将日期字段传递到json中
              customkeyVal = ''
              if (customkeyArrActJsonObj[customkey].isThisObj) {
                customkeyVal = this[customkeyArrActJsonObj[customkey].keyArr[1]]
              }
            }
            needPublicThemeData.actJson[
              customkeyArrActJsonObj[customkey].keyArr[0]
            ] = customkeyVal
          })
        }

        if (needPublicThemeData.analysisItemId == newData.data.analysisItemId) {
          // 动态拼接标题 测试
          // dataDimension[下拉框的字段]: filter.filterTypes 里面的字段
          // 自定义字符串的标识就是 【!$】 直接取后面的字符串使用
          // title: 原标题名字
          // needPublicThemeData.titleJoinKey = ['dataDimension', '!$-', 'title']
          // 访问发布主题接口

          // containerFull_common_data.js
          needPublicThemeData = this.createThemeItemBreforToFormat(
            needPublicThemeData,
            newData
          )
          console.debug('shareDoneEvent:', needPublicThemeData, newData.data)
          await this.createDataItem(needPublicThemeData, newData.data)
          //   publicThemeDialog
          this.$emit('shareDoneEvent', { flag: true })
        } else {
          console.debug('分享的analysisItemId值不相等')
        }
      }
      window.mixtmt_platfrom.needPublicThemeData = null
      this.publicThemeDialogObj = null
      this.dialogCancelEventHandler(null)
    },
  },
}
</script>
<!-- check总共高35.2vw,为了好看往下移一点 33 -->
